import { Box, Button, Grid, Stack, TextField } from "@mui/material";
import {
  SecondaryTypography,
  ErrorTypography,
  StyledTypography,
} from "../../../Theme";
import PhoneInput from "react-phone-input-2";
import { emailRegex } from "../../../utils/common";

const CompanyDetails = ({
  companyDetails,
  setCompanyDetails,
  errText,
  setErrText,
  setaddblocks,
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCompanyDetails((prev) => ({ ...prev, [name]: value }));
    setErrText((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handlePhoneChange = (value, countryData) => {
    const dialCode = countryData.dialCode; // Country's dial code
    setCompanyDetails((prev) => ({
      ...prev,
      company_contact_number: value, // Full phone number with country code
      company_country_code: dialCode, // Country code (dial code) alone
    }));
    setErrText((prev) => ({
      ...prev,
      company_contact_number: "",
    }));
  };

  console.log("companyDetails", companyDetails);
  const validateCompanyDetails = () => {
    let isValid = true;
    const contactNumberWithoutDialCode =
      companyDetails?.company_contact_number.slice(
        companyDetails?.company_country_code.length
      );

    const errors = {
      company_name: "",
      company_country: "",
      company_email_address: "",
      company_contact_number: "",
      company_contact_countrycode: "",
      company_address: "",
    };

    if (!companyDetails.company_name.trim()) {
      errors.company_name = "Company name is required";
      isValid = false;
    }

    if (!companyDetails.company_country.trim()) {
      errors.company_country = "Country is required";
      isValid = false;
    }
    if (
      companyDetails.company_country.length < 3 ||
      companyDetails.company_country.length > 20
    ) {
      errors.company_country = "Country must be between 3 and 20 characters";
      isValid = false;
    }

    if (!companyDetails.company_email_address.trim()) {
      errors.company_email_address = "Email address is required";
      isValid = false;
    } else if (!emailRegex.test(companyDetails.company_email_address)) {
      errors.company_email_address = "Enter a valid email address";
      isValid = false;
    }

    if (!companyDetails.company_contact_number.trim()) {
      errors.company_contact_number = "Contact number is required";
      isValid = false;
    }

    if (contactNumberWithoutDialCode.length < 6) {
      errors.company_contact_number =
        "Contact number must be at least 6 characters long (excluding dial code)";
      isValid = false;
    }

    if (!companyDetails.company_address.trim()) {
      errors.company_address = "Address is required";
      isValid = false;
    }
    if (companyDetails?.company_name !== "" && errText?.company_name) {
      errors.company_name = "Company name is already existed";
      isValid = false;
    }
    if (
      companyDetails.company_address.length < 3 ||
      companyDetails.company_address.length > 1000
    ) {
      errors.company_address = "Address must be between 3 and 1000 characters";
      isValid = false;
    }
    setErrText(errors);

    return isValid;
  };

  const handleContinue = () => {
    console.log("CompanyDetails", validateCompanyDetails());
    if (validateCompanyDetails()) {
      console.log("CompanyDetails", validateCompanyDetails());
      setaddblocks({
        Company_Details: false,

        Review_Information: true,
      });
    }
  };
  return (
    <>
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <SecondaryTypography>Company Details</SecondaryTypography>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Company Name</StyledTypography>
              <TextField
                name="company_name"
                placeholder="Enter Company Name"
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 50 }}
                value={companyDetails?.company_name}
                fullWidth
                onChange={(e) => handleInputChange(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errText.company_name ? "#912018" : "#111927",
                  },
                  backgroundColor: errText.company_name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />

              {errText?.company_name && (
                <ErrorTypography>{errText?.company_name}</ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Country</StyledTypography>
              <TextField
                name="company_country"
                placeholder="Country"
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
                value={companyDetails?.company_country}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errText.company_country ? "#912018" : "#111927",
                  },
                  backgroundColor: errText.company_country
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                onChange={(e) => handleInputChange(e)}
              />
              {errText?.company_country && (
                <ErrorTypography>{errText?.company_country}</ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Company Email Address</StyledTypography>
              <TextField
                name="company_email_address"
                placeholder="Enter Company Email Address"
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 125 }}
                value={companyDetails?.company_email_address}
                fullWidth
                onChange={(e) => handleInputChange(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errText.company_email_address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errText.company_email_address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {errText?.company_email_address && (
                <ErrorTypography>
                  {errText?.company_email_address}
                </ErrorTypography>
              )}
            </Grid>
            <Grid item xs={12} md={5.77}>
              <StyledTypography style={{ marginBottom: "10px" }}>
                Contact Number
              </StyledTypography>
              <PhoneInput
                inputProps={{ name: "phone", maxLength: 20 }}
                country={process.env.REACT_APP_COUNTRY_CODE || "sg"}
                name="company_contact_number"
                buttonStyle={{ border: "none" }}
                onChange={handlePhoneChange}
                value={companyDetails?.company_contact_number}
                inputStyle={{
                  backgroundColor: errText?.company_contact_number
                    ? "#FEE4E2"
                    : "#F9FAFB",
                  border: "none",
                  height: "46px",
                  width: "100%",
                  color: errText.company_contact_number ? "#912018" : "#111927",
                  borderRadius: "8px",
                }}
                countryCodeEditable={false}
              />
              {errText?.company_contact_number && (
                <ErrorTypography>
                  {errText?.company_contact_number}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12}>
              <StyledTypography>Company Address</StyledTypography>
              <TextField
                name="company_address"
                placeholder="Enter Company Address"
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 1000 }}
                fullWidth
                value={companyDetails?.company_address}
                onChange={(e) => handleInputChange(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errText.company_address ? "#912018" : "#111927",
                  },
                  backgroundColor: errText.company_address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {errText?.company_address && (
                <ErrorTypography>{errText?.company_address}</ErrorTypography>
              )}
            </Grid>
          </Grid>
        </Box>
        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
          sx={{
            backgroundColor: "white",
            border: "1px solid #E5E7EB",
            borderRadius: "0 0 8px 8px ",
          }}
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button
              type="button"
              sx={{ width: "fit-content" }}
              variant="Standard"
              onClick={handleContinue}
            >
              Continue
            </Button>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};
export default CompanyDetails;
